export const SOCIALS = [
  {
    image: 'tg',
    url: '',
  },
  {
    image: 'yt',
    url: '',
  },
  {
    image: 'vk',
    url: '',
  },
];
